// extracted by mini-css-extract-plugin
module.exports = {"row":"FileUpload_row__20pp1","dropzone":"FileUpload_dropzone__1vlaD","loader":"FileUpload_loader__2OMJU","fileDetails":"FileUpload_fileDetails__8skIX"};